import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plug, Loader2, Trash2, Webhook } from "lucide-react";
import { CassaSummary } from "../sala/CassaSummary";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const hdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } });

// Admin view of the Cassa in Cloud link: day takings + webhook activation (admin bearer is accepted by the /sala routes).
export function CassaAdminPanel({ day, services }) {
  const [status, setStatus] = useState(null);
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async (force = false) => {
    setBusy(true);
    try {
      const [s, d] = await Promise.all([axios.get(`${API}/sala/cassa/status`, hdr()), axios.post(`${API}/sala/cassa/sync`, null, { params: { date: day, force }, ...hdr() })]);
      setStatus(s.data); setData(d.data);
    } catch (e) { toast.error(e.response?.data?.detail || "Cassa in Cloud non raggiungibile"); }
    finally { setBusy(false); }
  };
  useEffect(() => { load(); }, [day]); // eslint-disable-line

  const setup = async () => {
    setBusy(true);
    try { await axios.post(`${API}/sala/cassa/webhooks/setup`, { base_url: window.location.origin }, hdr()); toast.success("Webhook Cassa in Cloud attivati"); await load(true); }
    catch (e) { toast.error(e.response?.data?.detail || "Attivazione fallita"); setBusy(false); }
  };
  const remove = async () => {
    if (!window.confirm("Disattivare i webhook Cassa in Cloud?")) return;
    setBusy(true);
    try { await axios.delete(`${API}/sala/cassa/webhooks`, hdr()); toast.success("Webhook rimossi"); await load(true); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); setBusy(false); }
  };

  if (!status) return null;
  if (!status.configured) return <div className="rounded-2xl border border-dashed border-[#e8dcc8] bg-white px-3 py-2 text-xs text-[#7c5a4e]" data-testid="cassa-admin-unconfigured">Cassa in Cloud: chiave API non configurata.</div>;
  const hooksOk = (status.webhooks || []).length >= 2;
  const sameOrigin = !status.webhook_url || status.webhook_url.startsWith(window.location.origin);
  return (
    <div className="space-y-2" data-testid="cassa-admin-panel">
      <CassaSummary data={data} services={services} loading={busy} onSync={() => load(true)} />
      <div className="flex flex-wrap items-center gap-2 text-xs text-[#7c5a4e] px-1">
        <Plug className="h-3.5 w-3.5 text-emerald-600" /> <span>{status.salespoint_name || "Punto vendita"} · ultimo sync {status.last_sync_at ? new Date(status.last_sync_at).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" }) : "—"}</span>
        <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-semibold ${hooksOk ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-900"}`} data-testid="cassa-webhook-state">
          <Webhook className="h-3 w-3" /> {hooksOk ? `webhook attivi${sameOrigin ? "" : " (altro dominio)"}` : "webhook non attivi · aggiornamento ogni minuto dal tablet"}
        </span>
        {status.last_webhook_at && <span>ultimo evento {new Date(status.last_webhook_at).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</span>}
        <div className="flex-1" />
        {!hooksOk || !sameOrigin ? (
          <button onClick={setup} disabled={busy} className="inline-flex items-center gap-1 rounded-full bg-[#4a1c17] text-white px-3 py-1.5 font-semibold disabled:opacity-50" data-testid="cassa-webhook-setup">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Webhook className="h-3.5 w-3.5" />} Attiva webhook su questo dominio</button>
        ) : (
          <button onClick={remove} disabled={busy} className="inline-flex items-center gap-1 rounded-full border border-[#e8dcc8] bg-white px-3 py-1.5 font-semibold text-rose-700" data-testid="cassa-webhook-remove"><Trash2 className="h-3.5 w-3.5" /> Disattiva webhook</button>
        )}
      </div>
    </div>
  );
}
